export default "__VITE_ASSET__CRL4aX0t__"